module.exports = __webpack_public_path__ + "img/Réalisation portail CFP.358edb3c.jpg";